import React, { useState } from "react";
import { FooterLink2 } from "../../data/footer-links";
import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";
import { FaFacebook, FaGoogle, FaTwitter, FaYoutube } from "react-icons/fa";

const BottomFooter = ["Privacy Policy", "Cookie Policy", "Terms"];
const Resources = [
  "Articles",
  "Blog",
  "Chart Sheet",
  "Code challenges",
  "Docs",
  "Projects",
  "Videos",
  "Workspaces",
];

const Footer = () => {
  const [email, setEmail] = useState("");

  return (
    <footer className="border-t border-white/10 bg-gradient-to-b from-richblack-800 to-richblack-900 font-inter text-white">
      <div className="mx-auto w-11/12 max-w-maxContent py-14">
        <div className="grid gap-12 border-b border-white/10 pb-12 lg:grid-cols-[1.1fr_1fr_1fr] xl:grid-cols-[1.1fr_1fr_1fr_1.2fr]">
          <div>
            <Link to="/" className="inline-block">
              <BrandLogo asLink={false} className="text-white" />
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/75">
              StudyNotion is a platform for practical online courses — structured paths, projects,
              and progress you can track.
            </p>
            <div className="mt-6 flex gap-3 text-lg text-white/80">
              <FaFacebook className="cursor-pointer transition hover:text-yellow-50" />
              <FaGoogle className="cursor-pointer transition hover:text-yellow-50" />
              <FaTwitter className="cursor-pointer transition hover:text-yellow-50" />
              <FaYoutube className="cursor-pointer transition hover:text-yellow-50" />
            </div>
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase tracking-wide text-yellow-50">Explore</h2>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              {["About", "Careers", "Affiliates"].map((ele) => (
                <li key={ele}>
                  <Link to={`/${ele.toLowerCase()}`} className="transition hover:text-white">
                    {ele}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/contact" className="transition hover:text-white">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase tracking-wide text-yellow-50">Resources</h2>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              {Resources.slice(0, 6).map((ele) => (
                <li key={ele}>
                  <Link to={`/${ele.split(" ").join("-").toLowerCase()}`} className="transition hover:text-white">
                    {ele}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3 xl:col-span-1">
            <h2 className="text-sm font-bold uppercase tracking-wide text-yellow-50">Newsletter</h2>
            <p className="mt-2 text-sm text-white/70">Get course tips and updates from StudyNotion.</p>
            <form
              className="mt-4 flex max-w-md gap-2"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="min-w-0 flex-1 rounded-lg border border-white/20 bg-white/10 px-3 py-2.5 text-sm text-white placeholder-white/45 outline-none ring-yellow-50 focus:ring-2"
              />
              <button
                type="submit"
                className="shrink-0 rounded-lg bg-yellow-50 px-4 py-2 font-semibold text-richblack-900 transition hover:bg-yellow-100"
                aria-label="Subscribe"
              >
                →
              </button>
            </form>
          </div>
        </div>

        <div className="hidden py-10 lg:block">
          <div className="grid gap-10 md:grid-cols-3">
            {FooterLink2.map((ele) => (
              <div key={ele.title}>
                <h3 className="text-sm font-bold text-yellow-50">{ele.title}</h3>
                <ul className="mt-3 space-y-2 text-sm text-white/75">
                  {ele.links.map((link) => (
                    <li key={link.title}>
                      <Link to={link.link} className="transition hover:text-white">
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-6 border-t border-white/10 pt-8 text-sm text-white/65 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap gap-2">
            {BottomFooter.map((ele, i) => (
              <span key={ele} className="flex items-center">
                {i > 0 && <span className="mx-2 text-white/30">|</span>}
                <Link to={ele.split(" ").join("-").toLowerCase()} className="hover:text-white">
                  {ele}
                </Link>
              </span>
            ))}
          </div>
          <p>© {new Date().getFullYear()} StudyNotion. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
